@if (this.condition) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
    <button mat-stroked-button color="primary" (click)="cancelRequest()">
      <mat-icon svgIcon="block"></mat-icon>
      <span>Cancelar</span>
    </button>
  </div>
}
